import { User } from '../models/user';
import { MyPageSettingsEnum } from '../models/enums/myPageSettings.enum';

export const getMyPageSetting = (currentUser: User | undefined, key: MyPageSettingsEnum, label: string) => {
  const foundSetting = currentUser?.mypageSettings.filter((x) => x.key === key)[0];
  return (foundSetting && foundSetting.value) || label;
};
